var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_1413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.20025e-05 7.60002C0.010022 3.39002 3.43002 -0.009978 7.66002 2.20023e-05C11.85 0.010022 15.24 3.45002 15.23 7.66002C15.22 11.86 11.78 15.24 7.54002 15.23C3.39002 15.21 -0.009978 11.77 2.20025e-05 7.60002ZM7.61002 9.26002C8.37002 10.02 9.09002 10.76 9.82002 11.48C10.32 11.97 11.02 11.98 11.49 11.52C11.98 11.04 11.98 10.34 11.48 9.82002C11.18 9.51002 10.88 9.21002 10.57 8.91002C10.15 8.49002 9.72002 8.07002 9.28002 7.64002C9.39002 7.52002 9.46002 7.44002 9.54002 7.36002C10.19 6.70002 10.85 6.06002 11.5 5.39002C11.95 4.93002 11.97 4.26002 11.55 3.79002C11.09 3.26002 10.33 3.24002 9.80002 3.76002C9.07002 4.48002 8.35002 5.22002 7.62002 5.96002C7.51002 5.85002 7.42002 5.78002 7.34002 5.70002C6.69002 5.05002 6.04002 4.39002 5.37002 3.74002C4.87002 3.25002 4.17002 3.26002 3.70002 3.74002C3.23002 4.22002 3.23002 4.91002 3.72002 5.41002C4.11002 5.81002 4.50002 6.20002 4.90002 6.59002C5.25002 6.93002 5.60002 7.25002 5.97002 7.60002C5.17002 8.39002 4.43002 9.12002 3.70002 9.86002C3.23002 10.35 3.24002 11.03 3.70002 11.51C4.16002 11.97 4.86002 11.99 5.35002 11.53C5.54002 11.36 5.71002 11.17 5.89002 10.99C6.45002 10.42 7.01002 9.86002 7.59002 9.27002L7.61002 9.26002Z",
    fill: "#EC1C24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_1413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.23,
    height: 15.23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b526afda699d758f929c286808891155.svg";
export { ForwardRef as ReactComponent };